/** A real checkbox with a real label. */

import { useEffect, useRef, type CSSProperties, type ReactNode } from "react";

import { cn } from "@/lib/cn";

import "./Checkbox.css";

export interface CheckboxProps {
  readonly label: ReactNode;
  readonly description?: ReactNode;
  readonly checked?: boolean;
  readonly defaultChecked?: boolean;
  readonly indeterminate?: boolean;
  readonly disabled?: boolean;
  readonly name?: string;
  readonly value?: string;
  readonly onChange?: (checked: boolean) => void;
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function Checkbox({
  label,
  description,
  checked,
  defaultChecked,
  indeterminate = false,
  disabled = false,
  name,
  value,
  onChange,
  className,
  style,
}: CheckboxProps) {
  const box = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (box.current) box.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <label className={cn("al-checkbox", disabled ? "al-checkbox-disabled" : undefined, className)} style={style}>
      <input
        ref={box}
        type="checkbox"
        className="al-checkbox-input"
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        name={name}
        value={value}
        onChange={(event) => onChange?.(event.target.checked)}
      />
      <span className="al-checkbox-main">
        <span className="al-checkbox-label">{label}</span>
        {description !== undefined ? (
          <span className="al-checkbox-description">{description}</span>
        ) : null}
      </span>
    </label>
  );
}
